export default __webpack_public_path__ + "static/media/infoIllustration3.23e201c6.gif";